<template>
  <footer>
    <div class="wrapper">
      <!--div class="bottom-img"></div-->
      <div class="nav-bottom">
        <div class="footerInfo w1260">
          <div class="top">
             <!-- <a><img src="@/assets/img/link1.gif"></a> -->
             <!-- <a><img src="@/assets/img/link2.gif"></a> -->
             <!-- <a><img src="@/assets/img/link3.gif"></a> -->
             <!-- <template v-if="siteOption">
              <a :href="siteOption['sns2Link']"><img src="@/assets/img/link4.gif"></a>
             </template> -->
             <!-- <div>
                <h4>{{ $t('front.mypage.community')}}</h4>
                <ul class="sns" v-if="siteOption">
                 <li @click="siteOption['sns2Link']">
                   <img src="@/assets/img/telegram.svg" />
                   <span><em>{{siteOption['sns2Id']}}</em></span>
                 </li>
                 <li @click="siteOption['sns1Link']">
                   <img src="@/assets/img/icon_kakao.svg" />
                   <span><em>{{siteOption['sns1Id']}}</em></span>
                 </li>
                 <li v-if="siteOption['sns3']" @click="siteOption['sns3Link']">
                   <img src="@/assets/img/zalo.svg" />
                   <span>{{siteOption['sns3']}}<em>{{siteOption['sns3Id']}}</em></span>
                 </li>
               </ul>
             </div> -->
          </div>
          <div class="bottom">
            <img src="@/assets/img/footer-img.png" />
          </div>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped>
.footerInfo ul li{cursor: pointer;}
</style>
